import { ToothDataEntry, ToothSurfaceDataType } from '../teethData';
import { ToothView } from '../../../Enums/ToothView.enum';
import { ToothSurface } from '../../../../../graphql/graphql';

export const Tooth85: ToothDataEntry = {
	[ToothView.INCISAL]: {
		surfaces: {
			[ToothSurface.Occlusal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M140.2,84.5s-3.2,9.4.2,19.8c0,0-3.8-1.5-11.5-1.5-7.7,0-19.4,11-34.3,11s-22.5-9.9-34.5-11.4-12.6.2-12.6.2c0,0,2.8-12.7.2-19.2,0,0,8.7.9,16.1.9s18.7-9,31.2-9,21.3,10.3,30.9,10.3c9.6,0,14.2-1.2,14.2-1.2Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M176.2,71.1l1.2,7.6.6,7.4.5,11.1v7.8s-.6,9.4-.6,9.4l-2.2,8s-21.2-15.1-35.4-18c0,0-3.4-9.2-.2-19.8,0,0,28.4-5.4,36-13.4Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M17.2,65.1l-2.6,3.1-2.1,5.7-1.6,4.3-.9,5.2v8.4c.1,0-.1,18.3-.1,18.3l.5,11.2s23.7-16.7,37.1-18.7c0,0,2.8-12.1.2-19.2,0,0-27.8-11.7-30.5-18.3Z',
			},
			[ToothSurface.MesioLingualCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M95.1,75.4s-8.6-48.3,1.6-48.3,24.3.2,24.3.2l9.3,1.4,8.8,2.3,7.3,2.7,6.2,3.8,6.1,5,7,7.4,4.9,5.9,3.5,7.3,1.8,4.9.5,3.3s-16.3,14.9-50.2,14.6c-14.2-.2-16.5-10.3-30.9-10.3Z',
			},
			[ToothSurface.DistoLingualCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M96.6,27l-29.3.3-8.8,1.7-7.1,2.1-6.4,2.7-4.1,1.5-3.3,2.7-4.2,3.2-3.9,3.8-4.6,4.9-2.3,3.8-3.2,4.7-2.2,6.7s2.1,7.1,30.5,18.3c0,0,8.8,1.6,16.1.9,12.1-1.1,9.4-5.8,31.2-9,0,0-8.4-47.4,1.6-48.3Z',
			},
			[ToothSurface.MesioBuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M91.3,113.7s-10.3,17.7,1.1,52.9l8.6-2.9,9.3.2,17.1-.8,10.6-3.1,6.6-2,6.7-3.5,6.7-5,5.4-4.7,4.6-6.4,3.4-5.2,2.3-6,2.2-4.8s-22.5-16-35.4-18c0,0-4-1.5-11.5-1.5s-18.8,12-37.7,10.9Z',
			},
			[ToothSurface.DistoBuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M10.4,121.3v6.4c0,0,.7,6,.7,6l1.8,4.7,5,4.5,3.8,2.9,4.7,1.7,3.7,1.7,2.7,2,4.1,3.6,5.6,4.5,4.6,2.8,5.6,2.8,6.3,2.4,5.5,1.4,5.2.9h12.4c0,.1,6.4-1,6.4-1l3.8-1.9c-11.2-36.2-1.1-52.9-1.1-52.9-12.2-1.3-19.8-9.6-31.1-11.3,0,0-6.8-1-12.6.2,0,0-10.5.3-37.1,18.7Z',
			},
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M99.3,164.6c-19.7,8.4-44.4,5-59.8-9.1-9.9-9-22.6-10.1-25.9-18.9s-3.5-20.2-3.3-30.7-.4-19,1.6-28.4,5.2-13,8.5-19.3c6.2-11.8,15.6-21.2,28.4-25.5s15.7-5.2,24.3-5.5c16-.6,31.5-.4,47.3.5,16.8.9,31.2,7.3,42.4,19.5,5.6,6.1,10.7,12.4,12.2,20.8,2.6,13.8,3.9,27.7,2.7,41.9-1.6,20.5-14.5,40.2-33.7,47.8-17.4,6.9-28.2,4.2-44.6,6.9Z',
			},
		},
	},
	[ToothView.LINGUAL]: {
		surfaces: {
			[ToothSurface.Lingual]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M102.7,400.4A7.6,7.6 0 1 0 87.5,400.4A7.6,7.6 0 1 0 102.7,400.4Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M141.1,450.6s-.6-27.8-.6-34.3,1.8-9.8,9.8-9.8c8,0,26.9,0,26.9,0v3.4c.1,0-.4,3.1-.4,3.1l-1,4.2-2.2,7.3-2.1,3.7-4.1,4.7-5.7,5.6-4.5,4.5-3.4,3.2-4.3,3-2.2,1.3h-6.2Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M20.5,392.8l-1.3,4.4-1.1,4.8-.6,4.3.6,6.4.5,3.3,2.5,6.5,5.4,8.1,5.5,8.4,7.7,9.1,8.4,6.4,3.8,2.3s0-46.9,0-52.9c0-6-2.9-10.4-9.3-10.4s-22.2-.6-22.2-.6Z',
			},
			[ToothSurface.CervicalLingual]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M164.8,370.6s-59.2-13.1-133.2,0l3.4-7.4s70.1-18.7,126.6,0l3.2,7.4Z',
			},
			[ToothSurface.MesioLingualCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M94.1,439.4l3.8-2.7h2.5c0,0,13,5,13,5l11,3.8,8.8,4.9h14.1s3.7-2.3,3.7-2.3l3.7-2.9,5.4-5.2,5.9-5.7,5.8-6.4,1.7-3.4,2.3-7.5,1.4-7.1v-3.4c-.1,0,.2-10.6.2-10.6l-1.4-6.2-2.4-5.6-2.8-4.5-3.3-4.9-2.7-4.1s-29.5-6.5-65.8-5.8c0,0-8.4,36.3-5,74.6Z',
			},
			[ToothSurface.DistoLingualCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M31.6,370.6l-3.6,5.5-3.2,6-2.9,6.2-1,3-.4,1.5-3.1,12.3,1.2,10.9,2.6,7.1,8.1,12,5.8,8.2,4.6,4.9,12.2,8.6h10.6c0,0,9.5-5.7,9.8-5.7s8.8-2.7,8.8-2.7l5.9-2.5,5.1-4.2,2-2.1s-3.8-32.5,5-74.6c0,0-27.7-1.1-67.4,5.8Z',
			},
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M106.6,439.7c-2.6-.9-6.7-3.7-9.3-2.6-6.3,5.6-12.4,10.3-20.7,12.5-9.7,2.5-16.8,13-29.9,3.6-9.7-7-16.1-16.6-22.3-26.8s-7.5-14.5-5.5-23.7l2.7-12.2,13.2-26.8,2.4-8.6c36.9,36,87,56.1,126,12.5l4.3,7.8c3.9,7,9.2,13.5,9.8,22,.7,10-.3,22-6.3,30.6s-13.3,15.1-21.2,20.6c-7.8,5.3-18.4,1.3-25.3-3s-11.2-3.8-17.9-6Z',
			},
		},
	},
	[ToothView.BUCCAL]: {
		surfaces: {
			[ToothSurface.Buccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M104.8,109.7A10.5,10.5 0 1 0 83.8,109.7A10.5,10.5 0 1 0 104.8,109.7Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M144.4,58l8.2-2.7h2.8c0,.1,3.5.9,3.5.9l5,4.3,7.2,7.4,5,5.5,2.8,10.2,1.1,10.5v6.4c-.1,0-1.6,4-1.6,4,0,0-20.2-.1-24-.1s-10.4-5.3-10.4-14.2c0-8.9.1-32.1.1-32.1Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M48.4,58.7l-8.7,5.7-5.5-3-8.7-1.4-6.8,1.8-4.3,4.3-3.3,6.2-2.8,6.5-2.6,9.5v5.8s2,7.7,2,7.7l1.4,3.7h28s11.4-1.4,11.4-13.6-.1-33.2-.1-33.2Z',
			},
			[ToothSurface.CervicalBuccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M168.3,120.7s-72.2,41.2-151.8,0l6.5,13.7s58.3,39.2,141.1,0l4.2-13.7Z',
			},
			[ToothSurface.MesioBuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M100.2,64.4l4.2,2.8,3.5.8h3.5c0-.1,3.2-2,3.2-2l10.5-4.2,8.6-2.2,11.8-2.5,5.2-1.8h1.9s6.4.8,6.4.8l17.2,17.2,3.1,10.8.8,14.1v2.2c-.1,0-1.3,4.2-1.3,4.2l-4.4,6.9-2.8,4.3-1.8,3.2-1.5,1.7s-31.3,17.8-73.8,18.3c0,0-4.7-47.9,5.6-74.6Z',
			},
			[ToothSurface.DistoBuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M100.2,64.4l-4.3-2.8-6.9-5-6.4-3.1-3.2-1.3-13-.2-6.3,1.4-9.2,3.6-2.6,1.6-8.7,5.7-5.5-3-8.7-1.4-6.8,1.8-4.3,4.3-3.4,6.6-2.7,6-.4,1.7-1.9,6.8-.2,4.2.2,3.3,1.1,4.8,1.2,3.8,1.2,3.9,2.8,6.6,4.2,6.8s33,19.4,78,18.3c0,0-4.9-43.6,5.6-74.6Z',
			},
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M179.2,88.2c3,17.1-5.6,22-12.2,34.9-43.6,21.6-100.7,15.8-147.4,4.3-12.8-21.8-18.6-38.5-5-60.7,5.5-9.1,15.5-7,25.1-1.7,10.8-8.2,23.5-13.7,37.1-12.6s21.5,14.2,30.7,16.1,13.1-6.9,27.4-8.4c11.9-1.2,19.8-10.4,31.1,2.7s10.1,7.6,13.2,25.3Z',
			},
		},
	},
};
